module.exports = __webpack_public_path__ + "img/電気回路_1_6_2.d013c0b1.png";